import React from 'react'
import Dashboard from '../Dashboard';
import TransactionsPaymentMain from './TransactionsPaymentMain'

export default function TransactionsPayment() {
    return (
        <div>
            <Dashboard cmp={<TransactionsPaymentMain />} />
        </div>
    )
}
